export default __webpack_public_path__ + "static/media/appstore.93234594.png";